import{defaultBreakpoint as e}from"../../utils/defaults.js";import{toMobileFontSize as t}from"../../utils/font-utils/to-mobile-font-size.js";import{isPixelValue as n}from"../../utils/line-height-to-px.js";const r=t=>`@media all and (max-width: ${e}) {
    .so-link-image td {width: 100%!important;}
  }@media all and (max-width: ${e}) {
    ${[i(t),u(t)].join(``)}

    .html-emails-button-mobile > table {
      width: 100%!important;
    }

    .html-emails-button-empty-div-mobile {
      display: none!important;
    }

    .PB24 .html-email-body-column > table > tbody > tr > td {
      padding-bottom: 24px!important;
    }

    .PT24 .html-email-body-column > table > tbody > tr > td {
      padding-top: 24px!important;
    }

    .PB24.html-email-body-column > table > tbody > tr > td {
      padding-bottom: 24px!important;
    }

    .PT24.html-email-body-column > table > tbody > tr > td {
      padding-top: 24px!important;
    }

    .PT16 .html-email-body-column > table > tbody > tr > td {
      padding-top: 16px!important;
    }

    .PR16 .html-email-body-column > table > tbody > tr > td {
      padding-right: 16px!important;
    }

    .PB16 .html-email-body-column > table > tbody > tr > td {
      padding-bottom: 16px!important;
    }

    .PL16 .html-email-body-column > table > tbody > tr > td {
      padding-left: 16px!important;
    }

    .PL0 .html-email-body-column > table > tbody > tr > td {
      padding-left: 0px!important;
    }

    .PR0 .html-email-body-column > table > tbody > tr > td {
      padding-right: 0px!important;
    }

    .MR16 > table > tbody > tr > td {
      padding-right: 16px!important;
    }

    .ML16 > table > tbody > tr > td {
      padding-left: 16px!important;
    }
  }@media all and (min-width: ${parseInt(e,10)+1}px) {
    .html-email-body-section-html .MRHTML16 {
      margin-left: 16px!important;
    }

    .html-email-body-section-html .MRHTML16 {
      margin-right: 16px!important;
    }
  }`;function i(e){let t=a(e).filter(e=>!!e.fontSize).reduce(o,{});return Object.keys(t).map(e=>`.${e}{font-size:${t[e]}px!important;}`).join(``)}function a(e){return Object.keys(e).map(t=>({className:t,fontSize:e[t].fontSize}))}function o(e,{className:n,fontSize:r}){return{...e,[n]:s(n,t(r))}}function s(e,t){return e===`so-global-footer-text`&&t<14?14:t}function c(e){return Object.keys(e).map(t=>({className:t,fontSize:e[t].fontSize,lineHeight:e[t].lineHeight,lineHeightRatio:e[t].originalLineHeight||1.4}))}function l(e,{className:r,fontSize:i,lineHeightRatio:a,lineHeight:o}){let s=n(o)?a:o;return{...e,[r]:t(i)*s}}function u(e){let t=c(e).filter(e=>!!e.lineHeight).reduce(l,{});return Object.keys(t).map(e=>`.${e}{line-height:${t[e]}px!important;}`).join(``)}export{r as buildCssMobile};
//# sourceMappingURL=build-css-mobile.js.map